import { createStyles } from "@mantine/core";

export const vinPageStyles = createStyles(() => ({
  orderedList: {
    li: {
      listStyle: "decimal",
      listStylePosition: "inside",
    },
    p: {
      display: "inline-block",
    },
  },
  explanationButton: {
    alignSelf: "flex-start",
  },
}));

export const vinGuideStyles = createStyles(() => ({
  title: {
    fontWeight: 500,
  },
  image: {
    width: "100%",
  },
}));
